<template>
  <el-dialog
    :visible.sync="innerVisible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    width="400px"
  >
    <div style="text-align: center;height: 200px">
      <el-form>
        <br>
        <br>
        <br>
        <br>
        <span>{{ $t('Menu.StandardLibrary2') }}</span>
        <br>
        <br>
        <el-form-item>
          <center>
            <cargo-advance-select
              ref="tenantSel"
              :select-type="selectTypeNames.TENANT"
              :cache="false"
              filterable
              :custom-label="companyLabel"
              :callback-params="{key:'relateTenantId'}"
              callback-method-type="value"
              :default-value="cboTenantId?cboTenantId:''"
              :static-options="standardList"
              style="width:200px"
              @parentCallBack="tenantIdChangeHandler"
            />
          </center>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="saveBasicHandler">{{ $t('Menu.Start') }}</el-button>
      <el-button type="primary" @click="closeHandler">{{ $t('Menu.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as initalDataApi from '@/api/sysManage/baseConfig/initalData'

export default {
  name: 'TenantWindow',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    tenantObj: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      selectTypeNames: TYPE_NAMES,
      cboTenantId: '',
      standardList: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (this.standardList.length === 0) {
        initalDataApi.findStandardAll().then(resp => {
          const rowData = resp.data.tenants
          rowData.forEach(row => { row.id = row.tenantId })
          this.standardList = rowData
        })
      }
    }
  },
  methods: {
    companyLabel(data) {
      if (data) {
        return '[' + data.id + ']' + data.name
      }
      return ''
    },
    tenantIdChangeHandler(item) {
      this.cboTenantId = item.value
    },
    saveBasicHandler() {
      const params = {}
      params.tenantId = Number(this.tenantObj.tenantId)
      params.copyTenantId = Number(this.cboTenantId)
      const loading = getLoading()
      initalDataApi.createInitalData(params).then(resp => {
        this.result(resp)
      }).finally(() => loading.close())
    },
    result(resp) {
      initalDataApi.updateInitalData(resp.data).then(res => {
        this.saveBasicResult(res)
      })
    },
    saveBasicResult(resp) {
      const data = resp.data
      let str = ''// 成功的
      let strFalut = ''// 失败的
      if (data.DMN_SEAPORT) {
        str += this.$t('SystemMaintenance.Seaport')
      } else {
        strFalut += this.$t('SystemMaintenance.Seaport')
      }
      if (data.DMN_AIRPORT) {
        str += this.$t('SystemMaintenance.Airport')
      } else {
        strFalut += this.$t('SystemMaintenance.Airport')
      }
      if (data.DMN_CHARGE_ITEM) {
        str += this.$t('SystemMaintenance.ChargeItem')
      } else {
        strFalut += this.$t('SystemMaintenance.ChargeItem')
      }
      if (data.DMN_REGION) {
        str += this.$t('SystemMaintenance.Route')
      } else {
        strFalut += this.$t('SystemMaintenance.Route')
      }
      if (data.DMN_NETWORK) {
        str += this.$t('SystemMaintenance.Network')
      } else {
        strFalut += this.$t('SystemMaintenance.Network')
      }
      if (data.DMN_CURRENCY) {
        str += this.$t('SystemMaintenance.Currency2')
      } else {
        strFalut += this.$t('SystemMaintenance.Currency2')
      }
      if (data.DMN_EQ_TYPE) {
        str += this.$t('SystemMaintenance.ContainerType')
      } else {
        strFalut += this.$t('SystemMaintenance.ContainerType')
      }
      if (data.DMN_PACKING) {
        str += this.$t('SystemMaintenance.Packaging')
      } else {
        strFalut += this.$t('SystemMaintenance.Packaging')
      }

      if (data.DMN_HOUSE_BL_TYPE) {
        str += this.$t('SystemMaintenance.BillOfLadingType2')
      } else {
        strFalut += this.$t('SystemMaintenance.BillOfLadingType2')
      }

      if (data.DMN_CARGO_TYPE) {
        str += this.$t('SystemMaintenance.CargoType')
      } else {
        strFalut += this.$t('SystemMaintenance.CargoType')
      }
      if (data.DMN_INCO_TERM) {
        str += this.$t('SystemMaintenance.TradeTerms')
      } else {
        strFalut += this.$t('SystemMaintenance.TradeTerms')
      }

      if (data.DMN_SHIPPING_TERM) {
        str += this.$t('SystemMaintenance.TransportTerms')
      } else {
        strFalut += this.$t('SystemMaintenance.TransportTerms')
      }

      if (data.SYS_TRADE_TERM) {
        str += this.$t('SystemMaintenance.TradeMode')
      } else {
        strFalut += this.$t('SystemMaintenance.TradeMode')
      }
      if (data.PRC_AIR_SERVICE) {
        str += this.$t('SystemMaintenance.AirFreightServiceItems')
      } else {
        strFalut += this.$t('SystemMaintenance.AirFreightServiceItems')
      }

      if (data.PRC_PORT_GROUP) {
        str += this.$t('SystemMaintenance.RelatedPort')
      } else {
        strFalut += this.$t('SystemMaintenance.RelatedPort')
      }
      if (data.SYS_OTHER_CHARGE_ITEM) {
        str += this.$t('SystemMaintenance.AirCargoBillMiscellaneous')
      } else {
        strFalut += this.$t('SystemMaintenance.AirCargoBillMiscellaneous')
      }
      if (data.SYS_CUSTOMER_TYPE) {
        str += this.$t('SystemMaintenance.CustomerType')
      } else {
        strFalut += this.$t('SystemMaintenance.CustomerType')
      }

      if (data.DMN_BL_MODE) {
        str += this.$t('SystemMaintenance.BillOfLadingMethod')
      } else {
        strFalut += this.$t('SystemMaintenance.BillOfLadingMethod')
      }
      if (data.DMN_CUSTOM_JOB_TYPE) {
        str += this.$t('SystemMaintenance.CustomBusinessType')
      } else {
        strFalut += this.$t('SystemMaintenance.CustomBusinessType')
      }

      if (data.DMN_TRANSMIT_FILE_TYPE) {
        str += this.$t('SystemMaintenance.CirculatingDocumentType')
      } else {
        strFalut += this.$t('SystemMaintenance.CirculatingDocumentType')
      }
      let str1 = this.$t('SystemMaintenance.Initialize')
      if (str) {
        str = str.substr(0, str.length - 1)
        str1 += str + this.$t('SystemMaintenance.Success')
      }
      if (strFalut) {
        strFalut = strFalut.substr(0, strFalut.length - 1)
        str1 += strFalut + this.$t('SystemMaintenance.Failure')
      }
      this.$message.success(this.$t('SystemMaintenance.Initialize') + str1)
      this.closeHandler()
    },
    closeHandler() {
      this.cboTenantId = ''
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
